var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16628_3591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 6.66663C12.5524 6.66664 13.0001 7.11436 13.0001 7.66664L13 12.3333C13 12.8856 12.5523 13.3333 12 13.3333C11.4477 13.3333 11 12.8856 11 12.3333L11.0001 7.66661C11.0001 7.11432 11.4478 6.66662 12.0001 6.66663Z",
    fill: "#121922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 16C13.3334 16.7363 12.7365 17.3333 12.0001 17.3333C11.2637 17.3333 10.6667 16.7363 10.6667 16C10.6667 15.2636 11.2637 14.6666 12.0001 14.6666C12.7365 14.6666 13.3334 15.2636 13.3334 16Z",
    fill: "#121922"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3334 12C21.3334 17.1546 17.1547 21.3333 12.0001 21.3333C6.84542 21.3333 2.66675 17.1546 2.66675 12C2.66675 6.8453 6.84542 2.66663 12.0001 2.66663C17.1547 2.66663 21.3334 6.8453 21.3334 12ZM19.3334 12C19.3334 16.05 16.0502 19.3333 12.0001 19.3333C7.94999 19.3333 4.66675 16.05 4.66675 12C4.66675 7.94987 7.94999 4.66663 12.0001 4.66663C16.0502 4.66663 19.3334 7.94987 19.3334 12Z",
    fill: "#121922"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16628_3591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBanner);
export default __webpack_public_path__ + "static/media/iconBanner.9294c5e1a7f37de6b466d74de1982c2b.svg";
export { ForwardRef as ReactComponent };